import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, LogIn } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-gradient noise-overlay relative flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="absolute top-1/4 -left-24 w-96 h-96 bg-brand-lime/15 rounded-full blur-3xl" />
      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <Link to="/"><img src="/assets/logo.png" alt="Neat & Proper" className="w-20 h-20 rounded-2xl mx-auto shadow-2xl mb-4" /></Link>
          <h1 className="font-display text-2xl font-extrabold text-white">Admin Console</h1>
          <p className="text-white/60 text-sm mt-1">Neat &amp; Proper — Clean Spaces, better living.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-2xl" data-testid="admin-login-form">
          {error && <div className="mb-4 px-4 py-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm" data-testid="admin-login-error">{error}</div>}
          <label className="block text-xs font-bold text-brand-emerald uppercase tracking-wider mb-1.5">Email</label>
          <div className="relative mb-4">
            <Mail className="w-4 h-4 text-brand-muted absolute left-4 top-1/2 -translate-y-1/2" />
            <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin email" className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#D6E4DC] text-sm focus:outline-none focus:ring-2 focus:ring-brand-lime/50" />
          </div>
          <label className="block text-xs font-bold text-brand-emerald uppercase tracking-wider mb-1.5">Password</label>
          <div className="relative mb-6">
            <Lock className="w-4 h-4 text-brand-muted absolute left-4 top-1/2 -translate-y-1/2" />
            <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full pl-11 pr-4 py-3 rounded-xl border border-[#D6E4DC] text-sm focus:outline-none focus:ring-2 focus:ring-brand-lime/50" />
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="w-full py-3.5 rounded-xl bg-brand-emerald text-white font-bold hover:bg-brand-lime disabled:opacity-50 transition-colors flex items-center justify-center gap-2">
            <LogIn className="w-4 h-4" /> {loading ? "Signing in…" : "Sign In"}
          </button>
          <Link to="/" className="block text-center text-xs text-brand-muted hover:text-brand-emerald mt-5 transition-colors">← Back to website</Link>
        </form>
      </div>
    </div>
  );
}
